/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const SCTransactionTypeFormatter = (cellContent, row, rowIndex) => {
  const { scTransactionType } = row;
  return (
    <>
      <div className="d-flex align-items-center">
        {scTransactionType ? scTransactionType : "-"}
      </div>
      <> </>
    </>
  );
};
